import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import { LoadingIndicator } from 'common/components/preloader';
import ArticleLink from 'help/components/article_link';
import CategoryLink from 'help/components/category_link';
import Sidebar from 'help/containers/sidebar';
import cookie from 'react-cookie';
import { Meta } from 'common/components/meta';
import { getCanonicalURL } from 'common/utils';
import first from 'lodash/first';
import keys from 'lodash/keys';
import { trackMixpanel, MP_VIEWED_MARKETING_PAGE_EVENT_NAME } from 'common/tracking';

export default class Article extends Component {
  constructor(props) {
    super(props);

    this.storeVote = this.storeVote.bind(this);
    this.upvote = this.upvote.bind(this);
    this.downvote = this.downvote.bind(this);
  }

  componentDidMount() {
    trackMixpanel("Viewed help content", {
      "contentType": "article",
      "pageType": "article page",
      "categorySlug": this.props.params.categorySlug,
      "slug": this.props.params.articleSlug,
    });
  }

  componentWillReceiveProps({ params, fetchArticleIfNeeded }) {
    if (params.articleSlug !== this.props.params.articleSlug) {
      fetchArticleIfNeeded();
    }
  }

  storeVote(up) {
    /* save vote in a cookie so it can be restored in future visits */
    cookie.save(`article_${this.props.article.data.id}_upvoted`, up, {path: '/'})
  }

  upvote() {
    this.storeVote(true)
    this.props.upvote()
  }

  downvote() {
    this.storeVote(false)
    this.props.downvote()
  }

  componentDidMount() {
    this.props.fetchAllCategoriesIfNeeded();
    this.props.fetchArticleIfNeeded();
  }

  render() {
    const { isLoading, categories, article, params } = this.props;

    if (!article.data || !categories.data || isLoading) {
      return <LoadingIndicator />;
    }

    const articleCategory = article.data.category;
    const content = { __html: article.data.body };
    /* remove empty objects from related articles list */
    const relatedArticles = (article.data.related_articles || []).filter(article => (
      keys(article).length > 0
    ));
    const upVoted = cookie.load(`article_${article.data.id}_upvoted`);

    return (
      <div className="help-content help-article">
        <Meta
          title={`${article.data.title} | Help | crowdspring`}
          meta={[
            { name: 'description', content: article.data.html_meta_description },
            { name: 'keywords', content: article.data.html_meta_keywords },
            { property: 'og:title', content: `${article.data.title}` },
            { property: 'og:url', content: getCanonicalURL(`/help/${params.categorySlug}/${article.data.slug}/`) },
            { property: 'og:description', content: article.data.html_meta_description },
          ]}
          link={[{ rel: "canonical", href: getCanonicalURL(`/help/${params.categorySlug}/${article.data.slug}/`) }]}
        />

        <div className="row column">
          <ul className="help-breadcrumb">
            <li><Link to="/help/">Help Center</Link></li>
            <li><CategoryLink {...articleCategory} /></li>
            <li className="active">{article.data.title}</li>
          </ul>
        </div>
        <div className="row">
          <article className="small-16 medium-10 large-11 columns">
            <h1 className="article-title">{article.data.title}</h1>
            <div
              className="article-content"
              dangerouslySetInnerHTML={content}
            />
            <div className="article-rating">
              <span>Was this article helpful?</span> {' '}
              <button className={"btn btn-icon-only upvote"  + (upVoted == "true"? " active":"")}
                      disabled={upVoted != undefined}
                      onClick={this.upvote}
              >
                { upVoted === "true" ?
                  <i className="fa fa-heart"/>:
                  <i className="fa fa-heart-o"/>
                }
                <span className="votes">{article.data.votes.helpful}</span>
              </button>
              <button className={"btn btn-icon-only downvote" + (upVoted == "false" ? " active":"")}
                      disabled={upVoted != undefined}
                      onClick={this.downvote}
              >
                { upVoted === "false" ?
                  <i className="fa fa-thumbs-down "/>:
                  <i className="fa fa-thumbs-o-down"/>
                }
                <span className="votes">{article.data.votes.total - article.data.votes.helpful}</span>
              </button>
            </div>
            { relatedArticles.length ?
              <div className="related-articles">
                <h4>Related Articles</h4>
                <ul className="article-list related">
                  { relatedArticles.map((article) => (
                    <li key={v4()}>
                      <ArticleLink {...article} categorySlug={article.category_slug} />
                    </li>
                  ))}
                </ul>
              </div> : null
            }
          </article>
          <aside className="small-16 medium-6 large-4 large-offset-1 columns">
            <Sidebar />
          </aside>
        </div>
      </div>
    );
  }
}

Article.propTypes = {
  fetchArticleIfNeeded: PropTypes.func.isRequired,
  fetchAllCategoriesIfNeeded: PropTypes.func.isRequired,
  upvote: PropTypes.func.isRequired,
  downvote: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  article: PropTypes.any,
  categories: PropTypes.object,
  params: PropTypes.shape({
    articleSlug: PropTypes.string.isRequired,
  }),
};



// WEBPACK FOOTER //
// ./help/components/article.jsx